import { ArrowLeft, Search } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import type { FdeCopy } from '@/frontend/features/Fde/types'

interface Props {
  query: string
  canGoBack: boolean
  visibleCount: number
  totalCount: number
  copy: FdeCopy
  onQueryChange: (value: string) => void
  onBack: () => void
}

export default function OntologySchemaToolbar(props: Props) {
  return <div className="flex h-11 shrink-0 items-center gap-2 border-b border-border bg-background px-3">
    {props.canGoBack && <Button type="button" size="icon-sm" variant="ghost" onClick={props.onBack} aria-label={props.copy.workspace.schema_back_previous}><ArrowLeft /></Button>}
    <div className="relative min-w-52 max-w-xl flex-1">
      <Search className="pointer-events-none absolute left-2.5 top-1/2 size-3.5 -translate-y-1/2 text-muted-foreground" />
      <Input value={props.query} onChange={(event) => props.onQueryChange(event.target.value)} placeholder={props.copy.workspace.schema_search} className="h-8 pl-8 text-xs" />
    </div>
    <span className="shrink-0 text-[10px] tabular-nums text-muted-foreground">{props.visibleCount} {props.copy.workspace.graph_of} {props.totalCount}</span>
  </div>
}
